import React, { forwardRef } from 'react'
import { TextProps } from 'rebass'
import { useSTheme } from 'styles/theme'
import { ResponsiveText } from '../styles'
import { fontSize } from '../../constants'

interface Props extends TextProps {
    maxLines?: number
    textStyles?: any
    text: string
}

const FParagraph = forwardRef<any, Props>((props: Props, ref) => {
    const theme = useSTheme()
    const fontFamily = theme.fontsV2?.[window.ORGANIZATION.name]?.body || theme.fontsV2.default

    return (
        <ResponsiveText
            style={{
                color: theme.colors.gray400,
                fontFamily: fontFamily,
                fontSize: fontSize.paragraph.desktop,
                ...props.textStyles,
            }}
            dangerouslySetInnerHTML={{ __html: props.text }}
        />
    )
})

FParagraph.displayName = 'FParagraph'

export default FParagraph
